﻿<template>

    <header class="header">
        <header_menu></header_menu>
    </header>

    <main class="p-4">
        <header_top></header_top>
        <div class="bg-grey-light grid grid-cols-1 lg:grid-cols-2 gap-4 p-2 my-2 border-2 rounded border-grey-default">
            <div>
                <passengers></passengers>
                <booking_notes></booking_notes>
            </div>
            <div><booking_details></booking_details></div>
        </div>
        <booking_documentation></booking_documentation>
    </main>

</template>

<script lang="ts" src="./details.ts"></script>